import { ReactElement, memo } from 'react';

import { useDriverCompanyStateInfo } from '~hooks/index';

import { DriverCompanyStateChipProps } from './types';
import { DriverCompanyStateChippRoot } from './styles';

const DriverCompanyStateChip = ({
  stateId,
  size = 'medium',
  variant = 'filled',
}: DriverCompanyStateChipProps): ReactElement => {
  const { description, color } = useDriverCompanyStateInfo(stateId);

  return (
    <DriverCompanyStateChippRoot
      variant={variant}
      label={description}
      color={color}
      size={size}
    />
  );
};

export default memo(DriverCompanyStateChip);
